import { memo } from 'react';
import { CursorArrowRaysIcon, PencilSquareIcon } from '@heroicons/react/24/solid';

interface Action {
    action: 'click' | 'setValue';
    id: string;
    element_text: string;
    newValue?: string;
}

interface ActionsProps {
    actions: Action[];
    config: any;
}

const Actions = memo(({ actions, config }: ActionsProps) => {
    const hexToRgb = (hex: string) => {
        hex = hex.replace(/^#/, '');
        let bigint = parseInt(hex, 16);
        let r = (bigint >> 16) & 255;
        let g = (bigint >> 8) & 255;
        let b = bigint & 255;
        return `${r}, ${g}, ${b}`;
    };

    return (
        <div className="flex flex-wrap gap-2 my-4 justify-center">
            {actions.map((action, index) => (
                <div
                    key={`${action.id}-${index}`}
                    className="flex items-center space-x-2 p-2 rounded-lg text-sm max-w-[250px]"
                    style={{
                        backgroundColor: `rgba(${hexToRgb(config.color)}, 0.08)`,
                        border: `1px solid rgba(${hexToRgb(config.color)}, 0.1)`,
                        color: `rgba(${hexToRgb(config.color)}, 0.7)`
                    }}
                >
                    {/* Action Icon */}
                    {action.action === 'click' ? (
                        <CursorArrowRaysIcon className="h-4 w-4 flex-shrink-0" />
                    ) : (
                        <PencilSquareIcon className="h-4 w-4 flex-shrink-0" />
                    )}
                    
                    {/* Action Text */}
                    <span className="whitespace-pre-wrap break-words">
                        {action.action === 'click' ? (
                            `Clicked button`
                        ) : (
                            `Set input to "${action.newValue}"`
                        )}
                    </span>
                </div>
            ))}
        </div>
    );
});

export default Actions;
